const AddOnIds = {
  CTCT_SMS_ADDON: 'CTCT-SMS-ADDON',
  CTCT_INBOX_PREVIEW_101: 'CTCT-INBOX-PREVIEW-101',
  CTCT_SEO_101: 'CTCT-SEO-101',
  CTCT_ARCHIVE_101: 'CTCT-ARCHIVE-101',
  CTCT_MARKETING_ASSISTANT_102: 'CTCT-MARKETING-ASSISTANT-102',
};

export default AddOnIds;
